import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useContent } from "@/hooks/useData";

export const Faq = () => {
  const { content } = useContent();
  const c = content.faq;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32" data-testid="faq-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow={c.eyebrow} title={c.title} accent={c.accent} />
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal>
            <Accordion type="single" collapsible className="w-full">
              {c.items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-[#ECEAE4]" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-xl sm:text-2xl font-medium text-[#2C2A29] hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#5E5A54] font-light leading-relaxed text-base pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
